import _ from 'lodash'
import app from 'xadmin'
import moment from 'moment'
import { RESTBaseAPI, use } from 'xadmin'
import fetch from './fetch'
import './getDeviceInfo'
import { fingerprint } from './getDeviceInfo'
import { noToken, noGetToken } from './noToken'

import lru from './lru'
// 兼容2.0老版本数据 #号问题
const idToCodeUrl = (id = '') => (_.includes(id, '#') ? encodeURIComponent(id) : id)

const cacheLru = true

export default class API extends RESTBaseAPI {

  constructor(options) {
    super(options)
    this.model = options
    this.host = this.getHost()
    this.headers = this.getHeaders(options)
    this.noToken = noToken()
    this.noGetToken = noGetToken()
    if (this.resource == undefined) {
      console.error(options)
      throw Error('resource is undefind')
    }
    if (this.resource.indexOf('auth') == 0) {
      this.resource = 'core/' + this.resource
    }
  }

  getHost() {
    return '/rest/'
  }

  getHeaders(options) {
    const { store } = app.context
    const user = store != undefined ? store.getState().user : null
    const settings = store != undefined ? store.getState().settings : null
    const methods = ['DELETE', 'PATCH', 'PUT']
    const hs = {
      'Content-Type': 'application/json'
    }
    if (fingerprint) {
      hs['X-Fingerprint'] = fingerprint
    }
    if (user && user.token) {
      let filterToken = []
      filterToken = this.noToken?.length ? this.noToken.filter(val => (val == this.resource)) : []
      filterToken = this.noGetToken?.length ? this.noGetToken.filter(val => {
        if (val == this.resource && options?.method == 'GET') return val
      }) : []
      if (filterToken?.length == 0) hs['Authorization'] = user.token
    }
    const lastPath = location.pathname.split('/').slice(-1)[0]
    if (lastPath.startsWith('_p_')) {
      hs['x-request-project'] = lastPath.substring(3)
    }
    if (app?.module !== 'front') {
      hs['X-Access-Path'] = 'admin'
    }
    if (settings?.safeRequest && methods.indexOf(options?.method) > -1) {
      hs['x-request-http-method'] = options?.method
    }
    return hs
  }

  fetch(uri, options) {
    const f = () => {
      const { store } = app.context
      const settings = store != undefined ? store.getState().settings : null
      const methods = ['DELETE', 'PATCH', 'PUT']
      let method = options?.method
      const router = location?.hash
      const user = store.getState()?.user || null
      const userPermissions = user?.permissions || []
      // 首页无权限接口取消调用
      // 非admin用户 
      if (!user?.isSuper && router == 'app/dashboard' && app?.module != 'front') {
        const modelName = this.resource.split('/')[1]
        // 根据接口名字与权限名称对应
        if (
          !_.includes(userPermissions, `${modelName}.view`) &&
          modelName != 'setting' &&
          modelName != 'theme' &&
          modelName != 'user' &&
          modelName != 'systemVariable'
        ) {
          return Promise.resolve()
        }
      }
      if (settings?.safeRequest && methods.indexOf(options?.method) > -1) {
        method = options?.method == 'DELETE' ? 'GET' : 'POST'
      }
      return fetch(this.getHost() + this.resource + uri, {
        ...options,
        method,
        headers: {
          ...(this.model && this.model?.headers || {}),
          ...(options && options.headers || {}),
          ...this.getHeaders(options),
        }
      })
    }
    if (cacheLru) {
      const cacheKey = this.resource + uri + JSON.stringify(options)
      if (lru.get(cacheKey)) {
        return lru.get(cacheKey)
      } else {
        const p = f()
        lru.set(cacheKey, p)
        return p
      }
    } else {
      return f()
    }
  }

  convert_format(value, schema) {
    if (value) {
      if (schema.format == 'datetime') {
        return moment(value).format('YYYY-MM-DD HH:mm:ss')
      } else if (schema.format == 'date') {
        return moment(value).format('YYYY-MM-DD')
      } else if (schema.type == 'array' && _.isArray(value)) {
        return value.map(i => this.convert_format(i, schema.items))
      } else if (schema?.properties && schema.type == 'object' && _.isPlainObject(value)) {
        Object.keys(schema.properties).forEach(k => {
          const p = schema.properties[k]
          value[k] = this.convert_format(value[k], p)
        })
      }
    }
    return value
  }

  convert_item(item, method = 'query') {
    //有的请求数据没有ID，需要用几个属性做联合ID
    if (this.model.idProp) {
      if ((typeof this.model.idProp) == 'object') {
        let unitId = ''
        for (let i of this.model.idProp) {
          unitId += item[i];
        }
        item = { ...item, id: unitId }
      }
      else {
        item = { ...item, id: item[this.model.idProp] }
      }
    } else if (item._id) {
      item.id = item._id
    }
    if (this.model.convertItem) {
      item = this.model.convertItem(item)
    }
    item = this.convert_format(item, this.model)
    return item
  }

  count(filter = {}) {
    let filter_string = encodeURIComponent(JSON.stringify({ where: filter['where'] || {} }))
    return this.fetch(`count?query=${filter_string}`).then(({ json }) => {
      return json['count']
    })
  }

  convert(f) {
    const query = {}

    if (!_.isEmpty(f.order)) {
      let ks = Object.keys(f.order)
        .filter(k => f.order[k] == 'ASC' || f.order[k] == 'DESC')
      if (ks.length > 0) {
        const sort = ks.reduce((prev, key) => ({ ...prev, [key]: f.order[key] == 'ASC' ? 1 : -1 }), {})
        //  资产编号 uid转id排序
        if (this.model?.name == 'node') this.convert_uidToId(sort)
        query.sort = sort
      }
    }

    if (!_.isNil(f.skip)) {
      query.skip = parseInt(f.skip)
    }
    if (!_.isNil(f.limit)) {
      query.limit = parseInt(f.limit)
    }
    if (!_.isNil(f.groupBy)) {
      query.groupBy = f.groupBy
    }

    if (!_.isEmpty(f.fields) || this.model.projectFields) {
      const allProject = [...(this.model.projectFields || []), ...(f.fields || [])]
      const level1 = allProject && allProject.filter(k => k.indexOf('.') == -1)
      const level2 = allProject && allProject.filter(k => k.indexOf('.') > 0)
      const allow = []
      level2.forEach((item, index) => {
        const p = item.slice(0, item.indexOf('.'))
        // 如果是外键不作处理
        if (p == 'model' || p == 'department' || p == 'node') {
          allow.push(level2[index])
        } else {
          if (level1.indexOf(p) == -1) allow.push(item)
        }
      })

      query.project = [...level1, ...allow,].reduce((prev, f) => ({ ...prev, [f]: 1 }), {})
    }

    return query
  }

  convert_value(value) {
    if (_.isPlainObject(value)) {
      // 适配公司查询
      if (value.id) {
        return value.id
      }

      let vs = _.omit(value, 'rule')

      return Object.keys(vs).reduce((prve, key) => {
        prve[key] = this.convert_value(vs[key])
        return prve
      }, {})

    } else if (_.isArray(value)) {
      return value.map(this.convert_where_value.bind(this))
    } else {
      // 去空格处理
      return value && _.isString(value) ? value.trim() : value
    }
  }

  convert_where_value(w) {
    const where = this.convert_where_filters(w)
    return _.isPlainObject(where) ? Object.keys(where).reduce((prev, key) => {
      // 关联数据加上Id
      let fieldKey = key
      const v = this.convert_value(where[key])
      const cv = this.convert_where_filters(v)
      if (_.isPlainObject(cv) && Object.keys(cv).length > 0 && Object.keys(cv)[0].indexOf('$') != 0) {
        prev = Object.keys(cv).reduce((p, k) => {
          if (k == 'gte' || k == 'lte') {
            p[fieldKey] = { ...p[fieldKey], [k]: cv[k] }
          } else {
            p[`${fieldKey}.${k}`] = cv[k]
          }
          return p
        }, prev)
      } else {
        const property = this.model.properties ? this.model.properties[fieldKey] : null
        // property.nullFilter属性定义是不是为空、不为空过滤 过滤为空、不为空的关联字段时 字段后面不拼Id
        // v为{ $in: [ null, {}, [] ] } 或 { $nin: [ null, {}, [] ] } 是为空、不为空过滤 字段后面不拼Id
        const nullValue = JSON.stringify([null, {}, []])
        const isFilterNull = v && _.isPlainObject(v) && (JSON.stringify(v['$in']) == nullValue || JSON.stringify(v['$nin']) == nullValue)
        if (property && (property.type == 'object' || property.type == 'array') && !property.nullFilter && !isFilterNull) {
          fieldKey = fieldKey + 'Id'
        }
        prev[fieldKey] = cv
      }
      return prev
    }, {}) : where
  }

  convert_uidToId(object = {}) {
    Object.keys(object).forEach(key => {
      if (key == 'uid') {
        object['id'] = object['uid']
        delete object['uid']
      }
    })
  }

  convert_where(wheres) {
    let where = _.values(wheres).map(w => this.convert_where_value(w))
    if (where.length > 0) {
      if (where.length > 1) {
        where = where.reduce((p, w) => ({ ...p, ...w }), {})
      } else {
        where = where[0]
      }
    } else {
      where = {}
    }
    // uid 查询转换 id
    this.convert_uidToId(where)
    return where
  }

  convert_where_filters(v) {
    if (!_.isPlainObject(v)) return v
    const ban = ['like', 'eq', 'gt', 'gte', 'in', 'inq', 'lt', 'lte', 'ne', 'nin', 'and', 'not', 'nor', 'or']
    const cv = Object.keys(v).map(item => {
      const o = v[item]
      if (_.isObject(o)) {
        let k = item
        if (ban.indexOf(item) >= 0 && item.indexOf('$') == -1) {
          k = [`$${item}`]
        }
        return { [k]: this.convert_where_filters(o) }
      } else {
        if (ban.indexOf(item) >= 0 && item.indexOf('$') == -1) {
          return { [`$${item == 'like' ? 'regex' : item}`]: o }
        } else {
          return { [item]: o }
        }
      }
    }).reduce((p, c) => ({ ...p, ...c }), {})

    return cv
  }

  query(filter = {}, wheres = {}, withCount = true, ...params) {
    const where = this.convert_where(wheres)
    const f = { ...params, ...this.model.queryParams, ...this.convert(filter) }
    if (Object.keys(where).length > 0) {
      // 浏览器url 内置页面 loadwarning报警小铃铛和全屏参数 参数不参与filter查询
      f['filter'] = _.omit(where, ['fullscreen', 'loadwarning'])
    }

    if (withCount) { f['withCount'] = true }
    let filter_string = encodeURIComponent(JSON.stringify(f))
    // console.log(filter, f, this.model, '===')
    if (this.model?.customQuery && _.isFunction(this.model.customQuery)) {
      return this.model.customQuery(this, filter, wheres, this.convert_item)
    }

    return this.fetch(`?query=${filter_string}`).then(({ json, headers }) => {
      return { items: json.map(this.convert_item.bind(this)), total: withCount ? headers['count'] : json.length }
    })
  }

  get(id = '') {
    const id_str = idToCodeUrl(id)
    return this.fetch(`/${this.resource == 'core/node' ? '_id/' + id_str : id_str}`)
      .then(({ json }) => {
        if (this.resource == 'core/user') {
          json = _.omit(json, 'password', 'password2')
        }
        return this.convert_item({ ...json, id })
      })
  }

  getOrigin(id = '') {
    const id_str = idToCodeUrl(id)
    return this.fetch(`/${this.resource == 'core/node' ? '_id/' + id_str : id_str}`)
  }

  delete(id = '') {
    const id_str = idToCodeUrl(id)
    return this.fetch(`/${id_str}`, { method: 'DELETE' }).then(({ json }) => ({ ...json, id }))
  }

  convert_data(data) {
    // Object.keys(data).forEach(key => {
    //   if (_.isPlainObject(data[key]) && data[key].id !== undefined) {
    //     data[key + '_id'] = data[key].id
    //   }
    // })
    return _.omit(data, ['__partial__'])
  }

  save(data = {}, partial = false) {
    if (this.resource == 'core/auth/logout') {
      return new Promise((resolve, reject) => resolve({}))
    }

    if (this.resource == 'core/auth/login') {
      return new Promise((resolve, reject) => {
        this.fetch('', {
          method: 'POST',
          body: JSON.stringify(data)
        })
          .then(({ json }) => resolve(json))
          .catch(({ json }) => reject({ json: { password: json ? json._error : '登录出现错误请联系系统管理员' } }))
      })
    }
    if (this.resource == 'core/setting') {
      return this.fetch('', {
        method: 'PATCH',
        body: JSON.stringify(this.convert_data(data))
      }).then(({ json }) => data)
    }

    if (data.id) {
      if (this.resource == 'core/node' || this.resource == 'core/department') {
        if (data.uid) {
          delete data['uid']
        }
      }

      return this.fetch(`/${idToCodeUrl(data.id)}`, {
        method: !partial ? 'PUT' : 'PATCH',
        body: JSON.stringify(this.convert_data(data))
      }).then(({ json }) => ({
        ...data,
        InsertedID: json?.InsertedID || json?.id
      }))
    } else {
      if (this.resource == 'core/node' || this.resource == 'core/department') {
        if (data.uid) {
          data.id = data.uid
          delete data['uid']
        }
        return new Promise((resolve, reject) => {
          return this.fetch('', {
            method: 'POST',
            body: JSON.stringify(this.convert_data(data))
          })
            .then(({ json }) => {
              resolve({
                ...data,
                id: json?.InsertedID || json?.id
              })
            })
            .catch(({ json }) => {
              if (json.id) {
                reject({ json: { uid: json.id } })
              } else {
                reject({ json })
              }
            })
        })
      }
      return this.fetch('', {
        method: 'POST',
        body: JSON.stringify(this.convert_data(data))
      })
        .then(({ json }) => {
          return {
            ...data,
            id: json?.InsertedID || json?.id
          }
        })
    }

  }

}

export { fetch }
